/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
export enum LogType {
    /**
     * 配置信息
     */
    runningData = 'runningdata',
    /**
     * 系统日志
     */
    system = 'system',
    /**
     * 硬盘日志
     */
    disk = 'disk',
    /**
     * 全量故障诊断信息
     */
    diagnostic = 'diagnose',
    /**
     * cloudBackup日志
     */
    cloudBackup = 'cloudbackup',
    /**
     * DHA运行日志
     */
    dha = 'dha',
    /**
     * HSSD日志
     */
    hssd = 'hssd',
    /**
     * 硬盘数据擦除报告
     */
    erase = 'erase',
    /**
     * 防病毒日志
     */
    antivirus = 'antivirus',
    /**
     * ftds log
     */
    ftds = 'ftds',
    /**
     * 性能文件
     */
    performanceFile = 'performanceFile',
    /**
     * 精简故障诊断信息
     */
    streamlineDiagnostic = 'streamlineDiagnostic',
    /**
     * 硬盘数据
     */
    DISK_RUNING_STATUS_DATA = 'diskData',
}

// getPath日志对象状态
export enum ResultCode {
    EXPORT_SUCCESS = 0,   // 成功
    EXPORTING = 1,  // 正在导出
    EXPORT_PARTLY = 2,  // 部分导出成功
    EXPORT_BUSY = 3,  // 繁忙
    EXPORT_FAIL = 4,  // 失败
    OFFLINE = 5,  // 导出节点不在线
    LACK_OF_RAM = 6,  // 导出节点内存不足
    CANCELED = 7,  // 已取消
    LOADING = 100,  // 正在下载
    LOAD_SUCCESS = 101,  // 下载成功
    LOAD_FAIL = 102,  // 下载失败
    DOWNLOAD_PART = 200  // 自定义：导出了sys log
}

// 导出日志url路径
export enum ExportNamespace {
    runningData = 'exportRunningData.get',
    systemLog = 'exportSystemLog.get',
    dhaLog = 'exportDHALog.get',
    hssdLog = 'exportHSSDLog.get',
    eraseLog = 'exportEraseLog.get',
    diagnoseData = 'exportDiagnoseData.get',
    cloudBackupLog = 'exportCloudBackupLog.get',
    antivirusLog = 'exportSystemLog.get',
    packagePerformanceFile = 'performanceData.package',
    getPackagePerformanceFileStatus = 'performanceData.getStatus',
    downloadPerformanceFile = 'performanceData.download',
    ftdsLog = 'exportFTDSLog.get'
}

export enum DownloadStatus {
    success = 'success',
    failed = 'failed',
    loading = 'loading'
}

export enum ErrorCode {
    ok = 0,
    packing = 83887409,  // 打包未完成
    noIPLog = 1073793331 // 非IP框环境
}

export enum PackagePerformanceFileStatus {
    idle = '--', // 空闲
    packaging = 'packaging', // 打包中
    downloading = 'downloading', // 下载中
    fault = 'fault', // 存储池故障
    none = 'none', // 性能存储空间或性能文件不存在
    failed = 'failed' // 性能文件打包失败
}

export enum PackageType {
    zip = 1
}
/**
 * 导出卡片时延item
 */
export interface ExportLogTimeOutItem {
    getpath?: number;
    download?: number;
    interval?: number;
    package?: number;
    check?: number;
    max?: number;
}

/**
 * 导出防病毒日志、FTDS日志下发item
 */
export interface ExportLogParamItem {
    key?: string;
    encryption?: 0 | 1;
    tag?: string;
    antivirus?: boolean;
}

export interface errorResult {
    result: {
        suggestion: string;
        description: string;
    };
}

export enum NodeType {
    CONTROLLER = 207,
    EXPANSION_BOARD = 208,
    DISK = 10
}

export enum IncludeManageLog {
    IS = '1',
    NOT = '0'
}

/**
 * 精简诊断日志关键信息展示方式
 */
export enum StreamlineDiagnosticShowWayTypeE {
    TEXT = 'text',
    QRCODE = 'qrcode'
}

export interface Controller {
    /** 管理对象类型。*/
    TYPE: NodeType;
    /** 控制器ID。*/
    ID: string;
    /** 控制器名称。*/
    NAME: string;
    /** 父对象类型编号。*/
    PARENTTYPE: number;
    /** 机框ID。*/
    PARENTID: string;
    /** 位置。*/
    LOCATION: string;
    /** 健康状态。*/
    HEALTHSTATUS: string;
    /** 运行状态。*/
    RUNNINGSTATUS: string;
    /** 描述信息。*/
    DESCRIPTION: string;
    /** Firmware版本。*/
    SOFTVER: string;
    /** 是否是主控。*/
    ISMASTER: string;
    /** 电子标签。*/
    ELABEL: string;
    /** PCB版本。*/
    PCBVER: string;
    /** SES版本。*/
    SESVER: string;
    /** BMC版本。*/
    BMCVER: string;
    /** 逻辑版本。*/
    LOGICVER: string;
    /** BIOS版本。*/
    BIOSVER: string;
    /** Cache大小。*/
    MEMORYSIZE: number;
    /** CPU信息。*/
    CPUINFO: string;
    /** 角色。*/
    ROLE: string;
    /** CPU占用率。*/
    CPUUSAGE: number;
    /** 内存使用率。*/
    MEMORYUSAGE: number;
    /** 电压值。*/
    VOLTAGE: number;
    /** 定位灯状态。*/
    LIGHT_STATUS: string;
    /** 脏页面的占用率。*/
    DIRTYDATARATE: number;
    /** 是否支持多工作模式。*/
    MULTMODE: string;
    /** 接口模块运行模式。*/
    RUNMODE: string;
    /** 支持的工作模式列表。*/
    RUNMODELIST: string;
    /** 温度。*/
    TEMPERATURE: number;
    /** 控制器类型。*/
    MODEL: string;
    /** 服务起始时间。*/
    startingPointDate: string;
    /** 服务时长。*/
    session: string;
    /** 序列号。*/
    sn: string;
    /** 控制行的可选 */
    disableCheck?: boolean;
}

export interface ExpansionBoard {
    /** 管理对象类型编号。*/
    TYPE: NodeType;
    /** 级联板ID。*/
    ID: string;
    /** 级联板名称。*/
    NAME: string;
    /** 父对象类型编号。*/
    PARENTTYPE: number;
    /** 框ID。*/
    PARENTID: string;
    /** 级联版位置，格式:用户框号.级联板槽位丝印。*/
    LOCATION: string;
    /** 健康状态。*/
    HEALTHSTATUS: string;
    /** 运行状态。*/
    RUNNINGSTATUS: string;
    /** 型号。*/
    MODEL: string;
    /** 逻辑版本。*/
    LOGICVER: string;
    /** PCB版本。*/
    PCBVER: string;
    /** SES版本。*/
    SESVER: string;
    /** 电子标签。*/
    ELABEL: string;
    /** 定位灯状态。*/
    LIGHTSTATUS: string;
    /** 序列号。*/
    sn: string;
    /** 控制行的可选 */
    disableCheck?: boolean;
}

export interface Disk {
    /** 管理对象类型。*/
    TYPE: NodeType;
    /** 硬盘ID。*/
    ID: string;
    /** 父对象类型编号。*/
    PARENTTYPE: number;
    /** 机框ID。*/
    PARENTID: string;
    /** 位置。*/
    LOCATION: string;
    /** 健康状态。*/
    HEALTHSTATUS: string;
    /** 运行状态。*/
    RUNNINGSTATUS: string;
    /** 硬盘类型。*/
    DISKTYPE: string;
    /** 扇区数量。*/
    SECTORS: number;
    /** 接口带宽。*/
    BANDWIDTH: number;
    /** 扇区大小。*/
    SECTORSIZE: number;
    /** 转速。*/
    SPEEDRPM: number;
    /** 温度。*/
    TEMPERATURE: number;
    /** 型号。*/
    MODEL: string;
    /** 固件版本号。*/
    FIRMWAREVER: string;
    /** 生产厂商。*/
    MANUFACTURER: string;
    /** 序列号。*/
    SERIALNUMBER: string;
    /** 定位灯状态。*/
    LIGHTSTATUS: string;
    /** 逻辑类型。*/
    LOGICTYPE: string;
    /** 所属POOL。*/
    POOLID: string;
    /** 所属POOL名称。*/
    POOLNAME: string;
    /** 所属Pool的Tier层。*/
    POOLTIERID: string;
    /** 是否保险箱盘。*/
    ISCOFFERDISK: string;
    /** 运行天数。*/
    RUNTIME: number;
    /** 重构、回拷、预拷贝、销毁等的进度。*/
    PROGRESS: number;
    /** 华为21码。*/
    barcode: string;
    /** 容量利用率。*/
    CAPACITYUSAGE: number;
    /** 盘的路径信息。*/
    MULTIPATH: string;
    /** 硬盘的健康评分。*/
    HEALTHMARK: number;
    /** 硬盘接口类型。*/
    DISKIFTYPE: string;
    /** 硬盘外形尺寸。*/
    DISKFORM: string;
    /** 对于不同接口的硬盘该值不同。*/
    DISKPORTADDR: string;
    /** 硬盘所在的SmartCachePool的ID。缓存盘情况下有用。*/
    SMARTCACHEPOOLID: string;
    /** 磨损度，磨损度指的是盘片已消耗的寿命百分比，是以消耗的写入数据量百分比。*/
    ABRASIONRATE: number;
    /** 剩余寿命。*/
    REMAINLIFE: number;
    /** 格式化进度。*/
    formatProgress?: number;
    /** 格式化剩余时间。*/
    formatRemainTime?: number;
    /** 盘AK开启状态。*/
    AUTOLOCKSTATUS: string;
    /** 加密盘密钥过期时间。*/
    KEYEXPIRATIONTIME: number;
    /** 加密盘类型。*/
    ENCRYPTDISKTYPE: string;
    /** 存储引擎ID。*/
    STORAGEENGINEID: string;
    /** 硬盘的BOM号。*/
    ITEM: string;
    /** 电子标签。*/
    ELABEL: string;
    /** 损失扇区数。*/
    REDUCESECTORS: number;
    /** 数据擦除进度。*/
    eraseProgess: number;
    /** 表示硬盘的厂商容量有多少个字节（1G = 1000 * 1000 * 1000 Byte）。*/
    manuCapacity: number;
    /** 盘的路径信息。*/
    diskDataPath: string;
}

/**
 * 导出日志的按钮
 */
export interface ExportLogBtn {
    /**
     * 按钮名称（下载时会变）
     */
    label?: string;
    /**
     * 按钮图标
     */
    icon?: string;
    /**
     * 按钮原始名称
     */
    originLabel?: string;
    /**
     * 是否处于下载中
     */
    loading?: boolean;
    /**
     * 是否可见
     */
    visible?: boolean;
    /**
     * 导出日志的时长和大小
     */
    tip?: string;
    /**
     * 导出日志的时间（极简模式使用）
     */
    time?: string;
    /**
     * 导出日志的大小（极简模式使用）
     */
    size?: string;
}

/**
 * 精简诊断日志关键信息
 */
export interface StreamlineDiagnostic {
    /**
     * 关键信息数据的base64编码返回
     */
    simplified_diagnose_info?: string;
    /**
     * 关键信息数据收集的文件名称
     */
    file_name?: string;
    /**
     * 关键信息数据的收集时间
     */
    date?: number;
}
